export const locale = {
    lang: 'nl',
    data: {
      'EDITOR': {
        'CARGANDO': 'Informatie laden',
        'GUARDANDO': 'Wijzigingen opslaan',
        'ELEMENTOS': {
          'GUIA': 'Elementen van dit blok',
          'COLORES': {
            'ORIGINAL': 'Ongewijzigd element',
            'MODIFICADO': 'Gewijzigd item'
          },
          'TOOLTIPS': {
            'ORIGINAL': 'Er is geen element gewijzigd',
            'MODIFICADO': 'Een of meer items zijn gewijzigd',
            'COMPLETO': 'Alle elementen zijn gewijzigd',
            'AMPLIAR': 'Bekijk in groot formaat',
            'ELIMINAR': 'Verwijder deze afbeelding',
            'IMPORTAR': 'Importeer dit item uit een andere taal',
            'CONFIGDOMINIO': 'Backend-domeinconfiguratie',
            'COPIARURL': 'Kopieer link'
          },
          'ETIQUETAS': {
            'INTERFAZ': {
              'TITULO': 'Configuratie door makelaar',
              'SUBTITULO': 'U kunt de instellingen van elke beschikbare makelaar bekijken en wijzigen',
              'PASOINICIAL': 'Selecteer een makelaar uit de lijst om zijn configuratie te tonen',
              'SELBROKER': 'Geselecteerde makelaar',
              'SELOPC': 'Geselecteerde optie',
              'SINJSONS': 'Kan informatie van deze makelaar niet laden, probeer het later opnieuw',
              'DOMINIO': {
                'TITULO': 'Configuratie van het back-enddomein van de makelaar',
                'ACTIVAR': 'Activeer het domein dat is gekoppeld aan de makelaar',
                'DOMINIO': 'Domein dat is gekoppeld aan de makelaar'
              },
              'MODAL': {
                'TITULO': 'Element importeren',
                'SUBTITULO': 'Selecteer de taal waaruit u dit item wilt importeren'
              }
            },
            'IMAGEN': {
              'NOHAY': 'Er is geen afbeelding',
              'ACTUAL': 'Huidige afbeelding'
            },
            'TEXTO': {
              'INGRESAR': 'Voer uw tekst in'
            },
            'VIDEO': {
              'NOVIDEO': 'Je hebt geen video geüpload',
              'GUARDANDO': 'Verlaat dit scherm niet voordat het uploaden is voltooid'
            }
          },
          'BOTONES': {
            'ENTRAR': 'Bewerk enquêtekenmerken',
            'REGRESAR': 'Ga terug',
            'CONTINUAR': 'Doorgaan met',
            'CANCELAR': 'annuleren',
            'GUARDAR': 'Wijzigingen opslaan',
            'IMAGEN': 'Verander afbeelding',
            'EDITOR': 'Bewerk bericht',
            'ELEMENTOS': 'Helpen',
            'ACTIVAR': 'Tonen',
            'DESACTIVAR': 'Zich verstoppen',
            'VERVIDEO': 'Bekijk de video',
            'CARGARVIDEO': 'Upload videobestand',
            'OTROVIDEO': 'Upload nog een videobestand',
            'SI': 'Ja',
            'NO': 'Nee',
            'INFO': 'Belangrijk',
            'ADDIMG': 'Voeg afbeelding toe'
          },
          'MODALIMAGEN': {
            'TITULO': 'Afbeelding toevoegen aan bericht',
            'TABS': {
              'INSTRUCCIONES': {
                'TITULO': 'instructies:',
                'PASO_1': 'Klik op het tabblad \'Afbeeldingen\', daar kun je een reeds geüploade afbeelding kiezen, of je kunt ook een nieuwe afbeelding uploaden',
                'PASO_2': 'Als u een reeds geüploade afbeelding wilt kiezen, kunt u door de cursor op de gewenste afbeelding te plaatsen twee acties uitvoeren: Bekijk de afbeelding of kopieer de link',
                'PASO_2_1': 'Om een ​​voorbeeld te bekijken, klik op de knop naar de knop op de afbeelding met het volgende pictogram:',
                'PASO_2_2': 'Om de link te kopiëren, klikt u op de knop naar de knop op de afbeelding met het volgende pictogram:',
                'PASO_3': 'Als u een nieuwe afbeelding wilt uploaden, klikt u op de knop met het volgende pictogram:',
                'PASO_4': 'Wanneer u klaar bent met het uploaden van de afbeelding, krijgt u automatisch de link',
                'PASO_5': 'Ga terug naar de berichteditor en klik op de knop om een ​​afbeelding in te voegen, met het volgende pictogram:',
                'PASO_6': 'Plaats in het pop-upvenster de gekopieerde link en stel de afbeeldingsgrootte in, uitgedrukt in pixels. Als u klaar bent, klikt u op de knop Opslaan. Het pop-upvenster wordt gesloten en de afbeelding wordt met de ingestelde grootte in de editor geplaatst'
              },
              'IMAGENES': {
                'TITULO': 'Afbeeldingen',
                'CARGANDO': 'Beschikbare afbeeldingen laden',
                'NOTA': '* De hier getoonde afbeeldingen zijn opgeslagen in de bestandsbeheerder',
                'TITULO_2': 'Beschikbare afbeeldingen',
                'ADD': 'Een nieuwe afbeelding toevoegen',
                'NOIMG': 'Geen afbeeldingen beschikbaar',
                'URLCOPIADA': 'Afbeeldingslink gekopieerd naar klembord',
                'OKBOT': ''
              },
            }
          }
        },
        'CATALOGOS': {
          'temas': {
            'temaFocusArea2': 'Kleurenset 1',
            'theme-temaIzzi': 'Kleurenset 2',
            'theme-blue-gray-dark': 'Kleurenset 3',
            'theme-pink-dark': 'Kleurenset 4',
            'theme-temaIzzi-2': 'Kleurenset 5',
            'theme-temaItbm': 'Kleurenset 6',
          },
          'numColumnas': {
            '1': '1 kolommen',
            '4': '4 kolommen',
            '5': '5 kolommen',
          },
          'segundos': {
            '1000': '1 seconde',
            '2000': '2 seconden',
            '3000': '3 seconden',
            '4000': '4 seconden',
            '5000': '5 seconden',
            '6000': '6 seconden',
            '7000': '7 seconden',
            '8000': '8 seconden',
            '9000': '9 seconden',
            '10000': '10 seconden',
            '11000': '11 seconden',
            '12000': '12 seconden',
            '13000': '13 seconden',
            '14000': '14 seconden',
            '15000': '15 seconden',
            '16000': '16 seconden',
            '17000': '17 seconden',
            '18000': '18 seconden',
            '19000': '19 seconden',
            '20000': '20 seconden',
          },
          'logosIniciales': {
            '0': 'CulturalGO-logo'
          }
        },
        'ADVERTENCIAS': {
          'URLEXTERNA': 'Waarschuwing: als de bronsite geen toegang tot de pagina vanaf externe sites toestaat, wordt de inhoud niet weergegeven',
          'TEMPLATEFALTANTE': 'Waarschuwing: dit sjabloon is niet beschikbaar voor deze taal',
          'CONFIGURACION': {
            'ACTIVAR': 'Let op: Bij het activeren van de aangepaste configuratie worden alle items die op dit scherm staan in de platforminterface geplaatst, zorg ervoor dat je alle juiste items hebt geplaatst \n\n Wil je doorgaan en de aangepaste configuratie activeren?',
            'DESACTIVAR': 'Let op: Bij het deactiveren van de aangepaste configuratie worden de standaardelementen die in het platform zijn vastgelegd voor deze broker en voor alle gebruikers die erbij horen geplaatst. \n\n Wilt u doorgaan en de gepersonaliseerde configuratie deactiveren?'
          },
          'PRIORIDAD': {
            '1': 'Als dit element actief is, wordt voorrang gegeven aan de achtergrondafbeeldingen',
            '2': 'Als dit element actief is, wordt voorrang gegeven aan de achtergrondafbeeldingen en de video-achtergrond.'
          }
        },
        'PANTALLAS': {
          'LOGIN': {
            'TITULO': 'Log in',
            'PASOS': {
              'VARIOS': {
                'TITULO': 'Allerlei voorwerpen',
                'ELEMENTOS': {
                  'images_broker': 'Logo van de makelaar',
                  'title': 'Hoofdtitel',
                  'images_login': 'Systeemlogo',
                  'images_logout': 'Afbeelding weergegeven bij uitloggen',
                  'changeTime': 'Tijdsinterval tussen afbeeldingen'
                }
              },
              'BACKGROUNDS': {
                'TITULO': 'Achtergrondafbeeldingen',
                'ELEMENTOS': {
                  'agregar': 'Voeg een afbeelding toe',
                  'importar': 'Importeer afbeeldingen uit andere instellingen',
                }
              },
              'VIDEO': {
                'TITULO': 'Achtergrondvideo',
                'ELEMENTOS': {
                  'enable': 'Schakel achtergrondvideo in',
                  'video': 'Video om te laten zien',
                  'loop': 'Schakel automatisch herhalen in',
                  'mute': 'Gedempte video weergeven'
                }
              },
              'EXTERNO': {
                'TITULO': 'Externe inhoud',
                'ELEMENTOS': {
                  'enable': 'Schakel externe inhoud in',
                  'url': 'Link van externe inhoud om weer te geven',
                }
              }
            }
          },
          'HOME': {
            'TITULO': 'Startpagina',
            'PASOS': {
              'BRAND':{
                'TITULO': 'Systeemidentiteit in het zijmenu',
                'ELEMENTOS': {
                  'logo': 'Systeemlogo',
                  'name': 'Systeem naam'
                }
              },
              'LOGOINICIAL': {
                'TITULO': 'Eerste logo',
                'ELEMENTOS': {
                  'show': 'Toon het eerste systeemlogo',
                  'time': 'Logo weergavetijd (uitgedrukt in seconden)',
                  'type': 'Initieel logo-type om weer te geven'
                }
              },
              'MOSAICO': {
                'TITULO': 'Mozaïek van afbeeldingen',
                'ELEMENTOS': {
                  'branding_show': 'Toon systeemmerklogo',
                  'branding_image': 'Systeemmerklogo',
                  'grayFilter': 'Grijs filter op opstartafbeeldingen',
                  'bgGridColumns': 'Aantal kolommen met afbeeldingen dat moet worden weergegeven'
                }
              },
              'TEMAS': {
                'TITULO': 'Platform kleurenthema',
                'ELEMENTOS': {
                  'theme': 'Kleurenthema om in het systeem weer te geven'
                }
              },
              'BACKGROUNDS': {
                'TITULO': 'Achtergrondafbeeldingen',
                'ELEMENTOS': {
                  'agregar': 'Voeg een afbeelding toe',
                  'importar': 'Importeer afbeeldingen uit andere instellingen',
                }
              },
              'VIDEO': {
                'TITULO': 'Achtergrondvideo',
                'ELEMENTOS': {
                  'enable': 'Schakel achtergrondvideo in',
                  'video': 'Video om te laten zien',
                  'loop': 'Schakel automatisch herhalen in',
                  'mute': 'Gedempte video weergeven'
                }
              },
              'EXTERNO': {
                'TITULO': 'Externe inhoud',
                'ELEMENTOS': {
                  'enable': 'Schakel externe inhoud in',
                  'url': 'Link van externe inhoud om weer te geven',
                }
              },
              'LOADER': {
                'TITULO': 'Afbeelding .gif wordt geladen',
                'ELEMENTOS': {
                  'image': 'Afbeelding .gif wordt geladen',
                  'GUARDANDO': 'Afbeelding wordt opgeslagen, sluit dit scherm niet af voordat het laden is voltooid'
                }
              },
            }
          },
          'TEMPLATES': {
            'TITULO': 'E-mailsjablonen',
            'PASOS': {
              'RT_1': {
                'TITULO': 'Technische vereisten, verzonden bij het registreren van een nieuw product',
                'ELEMENTOS': {
                  'asunto': 'Bericht Onderwerp',
                  'mensaje': 'Bericht lichaam'
                }
              },
              'RT_2': {
                'TITULO': 'Technische vereisten, demo-bericht verzonden tijdens validatie',
                'ELEMENTOS': {
                  'asunto': 'Bericht Onderwerp',
                  'mensaje': 'Bericht lichaam'
                }
              },
              'PASS_3': {
                'TITULO': 'E-mail verzonden bij het bijwerken van het gebruikerswachtwoord',
                'ELEMENTOS': {
                  'asunto': 'Bericht Onderwerp',
                  'mensaje': 'Bericht lichaam'
                }
              },
              'PASS_4': {
                'TITULO': 'E-mail verzonden bij het bijwerken van het gebruikersprofiel',
                'ELEMENTOS': {
                  'asunto': 'Bericht Onderwerp',
                  'mensaje': 'Bericht lichaam'
                }
              },
              'GETMYCODE_6': {
                'TITULO': 'E-mail verzonden met GetMyCode',
                'ELEMENTOS': {
                  'asunto': 'Bericht Onderwerp',
                  'mensaje': 'Bericht lichaam'
                }
              },
              'RT_7': {
                'TITULO': 'Mail voor acceptatie van technische vereisten',
                'ELEMENTOS': {
                  'asunto': 'Bericht Onderwerp',
                  'mensaje': 'Bericht lichaam'
                }
              },
            }
          }
        }
      }
    }
};
